import { css, html, LitElement } from "lit";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";

import "@shoelace-style/shoelace/dist/components/button/button.js";
import closeSvgJs from "../../../src/utils/assets/img/closeSvg.js";
import reloadIconSvg from "../../../src/utils/assets/img/reloadSvg.js";
import checkIconSvg from "../../../src/utils/assets/img/checkSvg.js";

export default class InvitedCofounder extends LitElement {
  static styles = css`
    .container {
      padding: 12px 0;
      border-bottom: 1px solid #f1f2f4;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #5a616e;
    }
    .buttons {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    sl-button::part(base) {
      padding: 0;
      min-height: unset;
      line-height: normal;
    }
    sl-button::part(label) {
      padding: 0;
    }
    .delete::part(label) {
      color: coral;
      font-size: 16px;
    }
    .cancel::part(label) {
      color: black;
      font-size: 16px;
    }
    #delete svg path {
      fill: coral;
    }
    .error-message {
      font-size: 12px;
      font-weight: 400;
      line-height: 150%;
      color: coral;
    }
    .warn-container {
      display: flex;
      flex-direction: column;
      gap: 7px;
    }
  `;

  static properties = {
    response: { type: String },
    resendSucceed: { type: Boolean },
    errorMessage: { type: Boolean },
    email: { type: String },
    showWarningTemplate: { type: Boolean },
    loading: { type: Boolean },
  };

  constructor() {
    super();
    this.email = "";
    this.response = "";
    this.resendSucceed = false;
    this.showWarningTemplate = false;
    this.loading = false;
  }

  updated(changedProperties) {
    if (changedProperties.has("response")) {
      if (this.response === "error") {
        this.errorMessage = true;
      } else if (this.response === "success") {
        this.resendSucceed = true;
      }
      this.response = "";
      this.loading = false;
    }

    let resendButton = this.shadowRoot.querySelector(".resend");
    if (resendButton) resendButton.loading = false;
  }

  handleButton(type) {
    this.dispatchEvent(
      new CustomEvent("handle-cofounder-button", {
        detail: { email: this.email, type: type },
        bubbles: true,
        composed: true,
      })
    );

    console.log("BUTTON", this.shadowRoot.querySelector(".delete"));
  }

  warningTemplate() {
    return html`<div class="warn-container">
      <span
        >This action will cancel the invitation for <b>${this.email}</b></span
      >
      <div class="buttons" style="gap: 24px; padding-top: 6px;">
        <sl-button
          variant="text"
          class="cancel"
          @click=${() => (this.showWarningTemplate = false)}
          >Cancel</sl-button
        >
        <sl-button
          variant="text"
          class="delete"
          @click=${(e) => {
            this.showWarningTemplate = false;
            this.handleButton("delete");
          }}
        >
          Confirm
        </sl-button>
      </div>
    </div>`;
  }

  render() {
    return html`<div class="container">
        ${!this.showWarningTemplate
          ? html`${this.email}
              <div class="buttons">
                <sl-button
                  variant="text"
                  class="resend"
                  ?disabled=${this.resendSucceed}
                  @click=${(e) => {
                    e.currentTarget.loading = true;
                    this.handleButton("resend");
                  }}
                  >${unsafeSVG(
                    !this.resendSucceed ? reloadIconSvg : checkIconSvg
                  )}</sl-button
                >
                <sl-button
                  variant="text"
                  ?loading=${this.loading}
                  id="delete"
                  @click=${(e) => {
                    this.showWarningTemplate = true;
                  }}
                >
                  ${unsafeSVG(closeSvgJs)}
                </sl-button>
              </div>`
          : this.warningTemplate()}
      </div>
      ${this.errorMessage
        ? html` <div class="error-message">
            Something went wrong. Try again later.
          </div>`
        : null} `;
  }
}

customElements.define("invited-cofounder", InvitedCofounder);
